import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import axios from "axios";
import useDeliveryPrice from "./useDeliveryPrice";

export default function () {
  const {reset, deliveryPriceFields, handleSubmit, setData, setErrors} = useDeliveryPrice();
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`/delivery-prices/${id}/edit`).then(res => {
      setData(res.data.data);

      reset(res.data.deliveryPrice);
    });
  }, []);

  const editPrice = data => {
    axios.put(`/delivery-prices/${id}`, data).then(res => {
      navigate('/delivery-prices');
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data.errors || {});
      }
    })
  }

  return (
    <Card title="Edit">
      <form className="form w-100 row" onSubmit={handleSubmit(editPrice)}>
        {deliveryPriceFields}
        <div className="col-12 mt-10">
          <SubmitButton
            title="Update"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}